module.exports = __webpack_public_path__ + "static/media/popupDelete.b5f72011.svg";